import React from 'react';
import PropTypes from 'prop-types';
import {
  Input as ReactstrapInput,
} from 'reactstrap';
import './styles.scss';

const Select = props => {
  const {
    name,
    items,
    value,
    onChange,
    hasError,
    errorMsg,
  } = props;

  items.unshift({value: null, label: ''})

  return (
    <div className="InputText">
      <ReactstrapInput
        value={value}
        name={name}
        type="select"
        onChange={onChange}
        className={hasError ? 'has-error' : ''}
      >
        {items.map(({value, label}) =>
          <option value={value} key={value}>
            {label}
          </option>
        )}
      </ReactstrapInput>
      {hasError &&
        errorMsg.length > 0 && (
        <div className="input-feedback has-error">{errorMsg}</div>
      )}
    </div>
  );
};

Select.defaultProps = {
  value: null,
  onChange: () => null,
  hasError: false,
  errorMsg: 'Il valore inserito non è valido',
};
Select.propTypes = {
  name: PropTypes.any.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
  })).isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  errorMsg: PropTypes.string,
};

export default Select;
